import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles, Dialog as MuiDialog, Slide } from '@material-ui/core';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles(theme => ({
    root: {
        borderRadius: 16,
        '& .MuiDialogTitle-root, & .MuiDialogTitle-root > *': {
            fontWeight: 'bold',
            fontSize: '1rem',
        },
        '& .MuiDialogContent-root': {
            fontSize: '0.938rem',
            textAlign: 'left',
        },
        '& .MuiDialog-paper': {
            borderRadius: 16,
        },
        '& .MuiDialogActions-root': {
            padding: '8px 24px 24px 24px',
        },
    },
}));

const Dialog = props => {
    const classes = useStyles();
    const { open, children, ariaLabelledby, ariaDescribedby, className, ...rest } = props;
    return (
        <MuiDialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            aria-labelledby={ariaLabelledby}
            aria-describedby={ariaDescribedby}
            className={clsx(classes.root, className)}
            {...rest}
        >
            {children}
        </MuiDialog>
    );
};

Dialog.propTypes = {
    open: PropTypes.bool,
    ariaLabelledby: PropTypes.string,
    ariaDescribedby: PropTypes.string,
    children: PropTypes.any.isRequired,
    className: PropTypes.string,
};

Dialog.defaultProps = {
    open: false,
    ariaLabelledby: 'alert-dialog-slide-title',
    ariaDescribedby: 'alert-dialog-slide-description',
    className: '',
};

export default Dialog;
